// src/api/noticeApi.js
import api from "../configs/axiosConfig";

// Expected backend: GET /api/notices?only_active=1
// Response: { notices: [ { notice_id, serial, text, url, is_active, ... } ] }
export async function getActiveNotices() {
  const res = await api.get("/notice/active_notices", {
    params: { only_active: 1 },
  });
  // If you return array directly, adapt: return res.data;
  return res.data.activeNotices || [];
}
